import { Resource as r, API as s } from "@coveo/platform-client";
const t = class t extends r {
  list() {
    return this.api.get(t.baseUrl);
  }
  /**
   * Get the replication limits of all logical indexes for an organization.
   *
   * @returns {Promise<ReplicationLimitsModel[]>}
   */
  getReplicationLimits() {
    return this.api.get(this.buildPath(`${t.baseUrl}/replication/limits`));
  }
};
t.baseUrl = `/rest/organizations/${s.orgPlaceholder}/logicalindexes`;
let i = t;
export {
  i as LogicalIndexesResource
};
//# sourceMappingURL=LogicalIndexesResource.js.map
